// Module
var code = "<button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#budgetModal\"> Calculer mon budget </button> ";
// Exports
module.exports = code;